import TOP from './TOP.base64'
import TOPDARK from './TOPDARK.base64';
export default {
  TOP,
  TOPDARK,
}